import React, { useEffect, Fragment, useState } from 'react';
import { Row, Col, Form, Button, message } from 'antd';
import FormGroup from 'Molecules/FormGroup';
import { useForm } from 'react-hook-form';
import { useTranslate } from 'Translate';

const _ = require('lodash');

export default (props) => {
  const { id, addDiscount, updateDiscount, meta, data, mode, reloadApi, allowedEdit } = props;
  const { control, formState: { errors }, handleSubmit, setValue } = useForm();
  const [selected, setSelected] = useState();
  const i18n = useTranslate();
  const { t } = i18n;

  const formFields = [
    {
      name: 'code',
      label: t("General.code"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'desc',
      label: t("General.desc"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'discount_method',
      label: t("Pos.discount_method"),
      req: true,
      type: 'select',
      options: meta?.discount_methods?.map((x) => ({ label: x, value: x })),
      placeholder: t("General.please_select"),
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit,
      onChange: (e) => {
        setSelected(e.value);
      }
    },
    {
      name: 'discount_amount',
      label: t("Pos.discount_rate"),
      req: true,
      number: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'max_discount_value',
      label: t("Pos.max_discount_val"),
      req: false,
      number: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit,
      hidden: selected !== "Percentage"
    },
    {
      name: 'max_discount_perc',
      label: t("Pos.max_discount_perc"),
      req: false,
      number: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit,
      hidden: selected === "Percentage"
    },
    {
      name: 'limit_by_qty',
      label: t("Pos.min_item_qty"),
      req: false,
      number: true,
      nostep: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'min_net_amount',
      label: t("Pos.min_net_amt"),
      req: true,
      number: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      type: 'switch',
      name: 'tax_included',
      label: t("Pos.min_net_amt_tax_inc"),
      req: false,
      twocol: false,
      colWidth: '0 1 50%',
      alignEnd: false, // move form to top
      labelPosition: 'top',
      static: !allowedEdit
    },
    {
      name: 'rounding_method',
      label: t("System.rounding_method"),
      req: false,
      type: 'select',
      options: meta?.rounding_methods?.map((x) => ({ label: x.label, value: x.value })),
      placeholder: t("General.please_select"),
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'rounding_step_size',
      label: t("System.rounding_step_size"),
      req: false,
      type: 'select',
      options: meta?.rounding_step_sizes?.map((x) => ({ label: x, value: x })),
      placeholder: t("General.please_select"),
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      type: 'switch',
      name: 'is_remark_required',
      label: t("Pos.is_remark_req"),
      req: false,
      twocol: false,
      colWidth: '0 1 50%',
      alignEnd: false, // move form to top
      labelPosition: 'top',
      static: !allowedEdit
    },
  ];

  useEffect(() => {
    if (data && 'id' in data) {
      setValue('code', data.code);
      setValue('desc', data.desc);
      setValue('discount_method', data.discount_method ? { label: data.discount_method, value: data.discount_method } : '');
      setValue('discount_amount', data.discount_amount);
      setValue('max_discount_value', data.max_discount_value);
      setValue('max_discount_perc', data.max_discount_perc);
      setValue('min_net_amount', data.min_net_amount);
      setValue('limit_by_qty', data.limit_by_qty);
      setValue('tax_included', data.tax_included === "1");
      setValue('is_remark_required', data.is_remark_required === "1");
      setSelected(data.discount_method);
      setValue('rounding_method', data.rounding_method ? { label: meta?.rounding_methods?.find(x => x.value === data?.rounding_method)?.label, value: data.rounding_method } : '');
      setValue('rounding_step_size', data.rounding_step_size ? { label: data.rounding_step_size, value: data.rounding_step_size } : '');
    }else{
      setValue('limit_by_qty', 1);
      setValue('rounding_method', { label: meta?.rounding_methods?.[0]?.label, value: meta?.rounding_methods?.[0]?.value });
      setValue('rounding_step_size', { label: meta?.rounding_step_sizes?.[0], value: meta?.rounding_step_sizes?.[0] });
    }
  }, [data, meta]);

  const onFinish = async (val) => {
    props.setLoading(true);
    const payload = {
      ...val,
      discount_method: val?.discount_method?.value,
      tax_included: val?.tax_included ? 1 : 0,
      is_remark_required: val?.is_remark_required ? 1 : 0,
      discount_id: id,
      rounding_method: val?.rounding_method?.value,
      rounding_step_size: val?.rounding_step_size?.value
    }

    await (mode === "add" ? addDiscount : updateDiscount)(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t(`Success.discount_${mode === "add" ? "created" : "updated"}`));
        reloadApi(res.data.data);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message);
    })
  };

  return (
    <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
      <Row gutter={[20, 30]}>
        {formFields.map((item, idx) => (
          <Fragment key={idx}>
            <FormGroup item={item} control={control} errors={errors} />
          </Fragment>
        ))}
        {
          allowedEdit &&
          <Col span={24} className='text-right'>
            <Button size="large" htmlType='submit' className='green-btn attendance-success'>{t("General.save")}</Button>
          </Col>
        }
      </Row>
    </Form>
  )
}